import { FormFields } from '~/libraries/forms/FormFields';
import type { FullGoalDefinitionViewModel } from '@generated';

export function PredefinedGoalFormFields({ fullGoalDefinition }: { fullGoalDefinition: FullGoalDefinitionViewModel }) {
	return (
		<>
			<div className="mb-4 flex flex-row items-center justify-between">
				<div className="border-b border-gray-100 px-5 py-4 ">
					<p className="text-base font-bold text-gray-900">{fullGoalDefinition.title}</p>
					<p className="mt-0.5 text-sm text-gray-500">{fullGoalDefinition.definitionText}</p>
				</div>
			</div>
			<FormFields formControls={fullGoalDefinition.definitionFormControls} formFields={fullGoalDefinition.definitionFormFields} />
		</>
	);
}
